import React from 'react';
import PropTypes from 'prop-types';
import { format } from '../../util/locale';
import styles from './TableFooter.module.scss';

const TableFooter = ({ totalResults }) => {
  const totalValue = format(totalResults, totalResults, 'int');
  return <div className={styles.container}>
    {totalResults && <div className={styles.results}>
      Total: {totalValue}
    </div>}
  </div>;
};

TableFooter.propTypes = {
  totalResults: PropTypes.number
};

export default TableFooter;
